module.exports = __webpack_public_path__ + "img/-LV18xuyZGv0bcBvQ0L2.faa779a7.jpg";